export enum EModalWidth {
  Small = 'screenMD',
  Medium = 'screenLGMin',
  Large = 'screenXL',
  ExtraSmall = 'screenSM',
  ExtraSuperSmall = 'screenXS',
}
